  $(document).ready(function(){
    $('.carousel-container').slick({
      slidesToScroll: 1,
      slidesToShow: 4.2,
      speed: 350,
      dots: true,
      arrows: true,
      infinite: false,
      prevArrow: `<button class="slide-arrow prev-arrow">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" fill="white"/>
        <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="black"/>
        <path d="M19.5008 24L27.0008 16.5L28.0508 17.55L21.6008 24L28.0508 30.45L27.0008 31.5L19.5008 24Z" fill="black"/>
        </svg>     
        </button>`,        
      nextArrow: `<button class="slide-arrow next-arrow">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="47.5" y="47.5" width="47" height="47" rx="23.5" transform="rotate(-180 47.5 47.5)" fill="white"/>
        <rect x="47.5" y="47.5" width="47" height="47" rx="23.5" transform="rotate(-180 47.5 47.5)" stroke="black"/>
        <path d="M28.4992 24L20.9992 31.5L19.9492 30.45L26.3992 24L19.9492 17.55L20.9992 16.5L28.4992 24Z" fill="black"/>
        </svg> 
        </button>`,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.1
          }
        }
      ]
    });
  }); 
